import gql from 'graphql-tag';

export const getEnrollableSessionsQuery = gql`
  query GetEnrollableSessionsQuery($courseId: String!, $userId: String!) {
    OnDemandSessionsV1Resource {
      nextEnrollableSessionsByUserAndCourse(courseId: $courseId, userId: $userId) {
        elements {
          id
          startedAt
          endedAt
          enrollmentEndedAt
        }
      }
    }
  }
`;
